import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, ArrowRight } from "lucide-react";
import { adminLogin } from "../../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      await adminLogin(email.trim().toLowerCase(), password);
      toast.success("Welcome back.");
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = Array.isArray(detail)
        ? detail.map((d) => d.msg).join(", ")
        : detail || err?.message || "Login failed.";
      toast.error(String(msg));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#001A4D] text-white font-body flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <img
            src="/brand/startinc-onnavy.png"
            alt="StartINC"
            className="h-10 w-auto mx-auto"
          />
          <p className="mt-4 text-xs uppercase tracking-[0.3em] text-[#6B8AFF] font-heading">
            Admin Console
          </p>
        </div>

        <form
          onSubmit={onSubmit}
          data-testid="admin-login-form"
          className="bg-white/5 backdrop-blur-xl border border-white/10 p-8 rounded-sm space-y-5"
        >
          <h1 className="font-heading font-light text-2xl tracking-tight">
            Sign in to manage posts
          </h1>

          <div>
            <label className="text-xs uppercase tracking-widest text-slate-300/70">
              Email
            </label>
            <div className="relative mt-2">
              <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                data-testid="admin-login-email"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-white/5 border border-white/15 text-white rounded-sm pl-10 pr-3 py-2.5 focus:outline-none focus:border-[#6B8AFF]"
                placeholder="contact@startinc.ae"
              />
            </div>
          </div>

          <div>
            <label className="text-xs uppercase tracking-widest text-slate-300/70">
              Password
            </label>
            <div className="relative mt-2">
              <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                data-testid="admin-login-password"
                type="password"
                required
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-white/5 border border-white/15 text-white rounded-sm pl-10 pr-3 py-2.5 focus:outline-none focus:border-[#6B8AFF]"
                placeholder="••••••••"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="btn-gold w-full justify-center disabled:opacity-60"
          >
            {submitting ? "Signing in…" : "Sign in"}
            {!submitting && <ArrowRight className="w-4 h-4" />}
          </button>
        </form>

        <p className="mt-6 text-center text-xs text-slate-400">
          Lost access? Contact your developer to reset.
        </p>
      </div>
    </div>
  );
}
